export default {
  // Default color applied by Chakra when using main color key: 500
  main: '#FFB300',
  white: '#FFFFFF',
  beige: {
    50: '#F4F0ED',
  },
  orange: {
    50: '#FEFAF0',
    100: '#FEFBF2',
    200: '#F5F4EA',
    300: '#FFF1BE',
    400: '#FFCE5C',
    500: '#FFB300',
    700: '#D69600',
    800: '#8C5E00',
    900: '#4E3400',
  },
  green: {
    50: '#F0FAF1',
    100: '#D5FCD3',
    400: '#1D9E75',
    500: '#35AA01',
    700: '#2E7D01',
    800: '#1A4D01',
    900: '#0D2E01',
  },
  blue: {
    500: '#378ADD',
  },
  purple: {
    500: '#7F77DD',
  },
  pink: {
    500: '#D4537E',
  },
  red: {
    50: '#FFEDF2',
    100: '#FED7D7',
    500: '#FF3F3B',
    600: '#DB0400',
    700: '#C92B1D',
    800: '#991518',
    900: '#67000A',
  },
  grey: {
    10: '#f4f4f4',
    20: '#E8E8E8',
    30: '#CFCFCF',
    50: '#D5D4D3',
    100: '#B1B1B1',
    200: '#747474',
    500: '#474747',
    900: '#333333',
  },
  blueGrey: {
    50: '#F7FAFC',
    100: '#EDF2F7',
    200: '#E2E8F0',
    300: '#CBD5E0',
    400: '#A0AEC0',
    500: '#718096',
    600: '#4A5568',
    800: '#264260',
    900: '#0B1D2B',
    1000: '#1B202B',
  },
  black: '#000000',
};
